export const config = {
  title: "MJF Landscaping and Hardscaping | Norwood, MA",
  meta: {
    description:
      "MJF Landscaping and Hardscaping provides expert patio, wall, deck, stair, and walkway construction along with complete outdoor living solutions in Norwood, MA and surrounding areas.",
    keywords: [
      "MJF Landscaping and Hardscaping",
      "landscaping Norwood MA",
      "hardscaping Norwood MA",
      "patio construction",
      "deck building",
      "walkway installation",
      "outdoor living spaces",
      "Norwood landscaping services"
    ],
    author: "MJF Landscaping and Hardscaping",
    canonicalUrl: "https://mjflandscapingllc.com/",
  },
  sections: {
    header: {
      businessName: "MJF Landscaping and Hardscaping",
    },
    sectionB: {
      heroTitle: "Transforming Homes with Quality Craftsmanship",
      heroSubtitle: "Expert Landscaping & Hardscaping in Norwood, MA",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "5082392722",
      phoneLabel: "(508) 239-2722",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2165425098/photo/laying-paving-stones-in-a-garden-pathway-on-a-sunny-day.jpg?s=612x612&w=0&k=20&c=ckXxWtx02-6tIKJCl9A3S9DpW3T9lKTQXQFbPiR0RCw=",
      cardData: [
        {
          title: "Patio Construction",
          description:
            "Custom patios designed and built to expand your outdoor living space.",
        },
        {
          title: "Deck & Stair Installation",
          description:
            "Durable decks and stairs built with precision and quality materials.",
        },
        {
          title: "Walkways & Walls",
          description:
            "Elegant walkways and sturdy retaining walls tailored to your property.",
        },
      ],
      description:
        "At MJF Landscaping and Hardscaping, we combine design expertise and craftsmanship to deliver stunning outdoor spaces. From patios and decks to walkways and custom outdoor living solutions, we help homeowners throughout Norwood and nearby towns achieve lasting beauty and functionality.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Explore our wide range of landscaping and hardscaping solutions designed to upgrade your home and outdoor living experience.",
      cards: [
        {
          title: "Patio Construction",
          description:
            "Beautiful, durable patios to expand your outdoor living areas.",
          imageSrc: "https://media.istockphoto.com/id/181091732/photo/a-workmans-gloved-hands-use-a-hammer-to-place-stone-pavers.jpg?s=612x612&w=0&k=20&c=Jp5MOWdrbvc94lZIwcTxGep1T8wn2Ja18LFTDQtvW5w=",
          imageAlt: "Patio Construction",
        },
        {
          title: "Deck Construction",
          description:
            "Custom-built decks designed to suit your lifestyle and home design.",
          imageSrc: "https://media.istockphoto.com/id/2164584939/photo/man-building-a-wooden-patio-deck-outdoors-in-his-garden.jpg?s=612x612&w=0&k=20&c=nRAgdZFsdfc7b_TDuxq5bA1UwDH29J9y3gWyX9cRKl0=",
          imageAlt: "Deck Construction",
        },
        {
          title: "Walkways & Stair Installation",
          description:
            "Safe, stylish walkways and stairs that enhance accessibility and appeal.",
          imageSrc: "https://media.istockphoto.com/id/2207293414/photo/plastic-tiles-with-perforations-and-locks-are-suitable-for-building-roads-and-parking-lots.jpg?s=612x612&w=0&k=20&c=qZIIy_jWlZ9mVgov4PJUzRF-hmjlMMTUNXHBv1uz498=",
          imageAlt: "Walkways & Stairs",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Retaining Wall Construction",
        "Outdoor Living Spaces",
        "Custom Landscaping Design",
        "General Contracting & Repairs",
        "Free Estimates with Warranty",
      ],
    },
    sectionD: {
      aboutTitle: "About MJF Landscaping and Hardscaping",
      aboutImage: {
        src: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://storage.googleapis.com/msgsndr/XbXpEFjtdcNteZWNpYIk/media/68c234743e4f38b91b34133c.jpeg",
        alt: "MJF Landscaping Team",
      },
      aboutText: [
        "At MJF Landscaping and Hardscaping, we bring years of experience and a commitment to excellence to every project.",
        "Based in Norwood, MA, our team is dedicated to delivering durable, reliable, and stylish outdoor spaces for residential and commercial clients across Westwood, Dedham, Sharon, Canton, Walpole, and Medfield.",
      ],
    },
    sectionE: {
      profileImage: "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/XbXpEFjtdcNteZWNpYIk/media/68c1c837353d130f2dfe9dfb.png",
      profileAlt: "MJF Landscaping and Hardscaping Logo",
      businessName: "MJF Landscaping and Hardscaping",
      contact: {
        phone: "5082392722",
        phoneLabel: "(508) 239-2722",
        email: "MjfLandscapingandhardscaping@gmail.com",
        website: "https://mjflandscapingllc.com/",
        address: "Norwood, MA 02062",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Norwood, MA 02062",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2947.937937469627!2d-71.2070!3d42.1940!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e37cfd19be4d7f%3A0xf1a5f7a940a8e23d!2sNorwood%2C%20MA%2002062!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;
